import {AxiosInstance, AxiosRequestConfig} from "axios";
import {ChannelStore} from "@/store/modules/ChannelStore";
import {AppYnStore} from "@/store/modules/AppYnStore";

function getFullChannelId(channelId: string): string {
    const suffix = (AppYnStore as any).state.appYn === 'Y' ? 'app' : 'web';
    return `${channelId}_${suffix}`;
}


export const channelHeaderInterceptor = (instance: AxiosInstance) => instance.interceptors.request.use(
    function (config: AxiosRequestConfig) {
      const channelId = (ChannelStore as any).state.channelId;
      config.headers['x-giftshop-channel-id'] = getFullChannelId(channelId);
      return config;
    },
);